import React, { useState, useEffect } from "react";
import { View, Modal, FlatList } from "react-native";
import config from "../../config/config";
import AppButtonGoBack from "../buttons/AppButtonGoBack";
import Screen from "../Screen";
import ListItem from "../lists/ListItem";
import IconTouchable from "../IconTouchable";
import useApi from "../../hooks/useApi";
import vehiclesApi from "../../api/vehicles";
import ListItemTextInput from "../lists/ListItemTextInput";
import Icon from "../Icon";
import BlockSeperator from "../BlockSeperator";
import useUser from "../../hooks/useUser";
import AppText from "../AppText";

function VehiclePicker({ title, value, itemID, onComplete, editable = true, onChange = () => {} }) {
    const [selectedVehicle, setSelectedVehicle] = useState(value);

    const [modalVisible, setModalVisible] = useState(false);
    const [newModalVisible, setNewModalVisible] = useState(false);

    const [message, setMessage] = useState(false);

    const { user } = useUser();
    const [registration, setRegistration] = useState();

    const getVehiclesApi = useApi(vehiclesApi.getVehicles);
    const addVehicleApi = useApi(vehiclesApi.addVehicle);
    const deleteVehicleApi = useApi(vehiclesApi.deleteVehicle);

    const [vehicles, setVehicles] = useState([]);
    const [searchTerm, setSearchTerm] = useState();

    useEffect(() => {
        if (!modalVisible) {
            return;
        }
        getVehicles();
    }, [modalVisible]);

    const getVehicles = async () => {
        const response = await getVehiclesApi.request();
        if (response.ok) {
            setVehicles(response.data);
        }
    };

    const handleSelect = async (vehicle) => {
        if (onComplete) {
            await onComplete.request(itemID, vehicle);
        }
        onChange(vehicle);
        setSelectedVehicle(vehicle);
        setModalVisible(false);
    };

    const handleAdd = async () => {
        const response = await addVehicleApi.request(registration);
        if (response.ok) {
            getVehicles();
            setNewModalVisible(false);
        } else {
            setMessage("Unable to add Vehicle");
        }
    };

    const handleDelete = async (vehicle) => {
        const response = await deleteVehicleApi.request(vehicle._id);
        if (response.ok) {
            getVehicles();
        } else {
            setMessage("Error removing Vehicle - Please Contact Support");
        }
    };

    return (
        <View>
            <ListItem
                headerComponent={
                    selectedVehicle && (
                        <>
                            <AppText>{selectedVehicle.year + " " + selectedVehicle.make + " " + selectedVehicle.model}</AppText>
                            <AppText>{"Engine Code: " + selectedVehicle.engineCode}</AppText>
                            <AppText>{"Engine Size: " + selectedVehicle.engineSize}</AppText>
                        </>
                    )
                }
                title={"Vehicle"}
                utilityComponent={
                    editable && (
                        <IconTouchable name="car" backgroundColor={config.colors.tertiary} iconColor={config.colors.white} size={55} onPress={() => setModalVisible(true)} />
                    )
                }
            />

            <Modal visible={modalVisible} animationType="slide">
                <Screen
                    title={"Select Vehicle"}
                    leftIconComponent={
                        <AppButtonGoBack
                            onPress={() => {
                                setModalVisible(false);
                            }}
                        />
                    }
                    rightIconComponent={user.type == "admin" && <IconTouchable name="plus-circle" onPress={() => setNewModalVisible(true)} />}
                >
                    <FlatList
                        data={
                            searchTerm
                                ? vehicles.filter((vehicle) => {
                                      if (vehicle.make.toUpperCase().indexOf(searchTerm.toUpperCase()) > -1) {
                                          return vehicle;
                                      }
                                      if (vehicle.model.toUpperCase().indexOf(searchTerm.toUpperCase()) > -1) {
                                          return vehicle;
                                      }
                                  })
                                : vehicles
                        }
                        keyExtractor={(item) => item._id}
                        ListHeaderComponent={
                            <View>
                                <ListItemTextInput
                                    title="Vehicle Search"
                                    onChange={(searchTerm) => {
                                        setSearchTerm(searchTerm);
                                    }}
                                />
                            </View>
                        }
                        extraData={searchTerm}
                        renderItem={({ item }) => (
                            <ListItem
                                title={"REG: " + item.registration}
                                subTitle={item.year + " " + item.make + " " + item.model}
                                subTitle2={"Engine Code: " + item.engineCode}
                                onPress={async () => {
                                    handleSelect(item);
                                }}
                                IconComponent={
                                    user.type == "admin" && <IconTouchable name="trash-can" size={40} iconColor={config.colors.danger} onPress={() => handleDelete(item)} />
                                }
                                utilityComponent={<Icon iconColor={config.colors.tertiary} backgroundColor={config.colors.white} name={"arrow-right"} />}
                            />
                        )}
                    />
                </Screen>
                <Modal visible={newModalVisible} animationType="slide">
                    <Screen
                        leftIconComponent={
                            <AppButtonGoBack
                                onPress={() => {
                                    setNewModalVisible(false);
                                }}
                            />
                        }
                        title={"New Vehicle"}
                        message={message}
                        setMessage={setMessage}
                    >
                        <ListItemTextInput title="Registration" onChange={(text) => setRegistration(text)} />
                        <BlockSeperator />
                        <ListItem title="Add Vehicle" utilityComponent={<IconTouchable name="check" onPress={() => handleAdd()} />} />
                    </Screen>
                </Modal>
            </Modal>
        </View>
    );
}

export default VehiclePicker;
